import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { paymentTermUpdate } from '../../../redux/actions/paymentTerms';

const EditPaymentTermModal = ({ payload, showEditPaymentTermModal, setShowEditPaymentTermModal, paymentTerm, editPaymentTerm }) => {
  const [termName, setTermName] = useState(null);
  const [period, setPeriod] = useState(null);

  const paymentTermJson = () => {
    return {
      term_name: (termName || paymentTerm.term_name),
      shipping_terms: (period || paymentTerm.shipping_terms)
    }
  }

  const changeName = (event) => {
    let value = event.target.value;
    setTermName(value);
  }

  const changePeriod = (event) => {
    let value = event.target.value;
    setPeriod(value);
  }

  const update = () => {
    editPaymentTerm(payload, paymentTerm.id, paymentTermJson());
    setShowEditPaymentTermModal(false);
  }

  return(
    <>
      { paymentTerm &&
        <Modal
          actions={[
            {
              text: 'Cancel',
              variant: 'subtle',
              onClick: () => setShowEditPaymentTermModal(false),
            },
            { text: 'Update Payment Term', onClick: () => update() },
          ]}
          closeOnClickOutside={true}
          closeOnEscKey={true}
          header="Update Payment Term"
          isOpen={showEditPaymentTermModal}
          onClose={() => setShowEditPaymentTermModal(false)}
        >
          <H3>Update {paymentTerm.term_name}</H3>
          <Input
            description={`Current value: ${paymentTerm.term_name}`}
            label="Payment Name"
            onChange={changeName}
            placeholder="Payment Name"
            type="text"
            value={termName}
            required
          />
          <Input
            description={`Current value: ${paymentTerm.shipping_terms}`}
            label="Payment Period (days)"
            onChange={changePeriod}
            placeholder="Payment Period (days)"
            type="number"
            min="0"
            value={period}
            required
          />
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  editPaymentTerm: (payload, paymentTermId, paymentTerm) => dispatch(paymentTermUpdate(payload, paymentTermId, paymentTerm)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPaymentTermModal);